import { Form, Spin, Typography } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../../components/layouts/enhancement/MainLayout";
import TopContent from "../../components/layouts/enhancement/TopContent";
import cnt from "../../services/definedConstant";
import { BOM } from "../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "./serviceProvider.config";
import dayjs from "dayjs";
import Notiflix from "notiflix";
import { useDispatch } from "react-redux";
import "../../assets/styles/InterbankPlacement.css";
import { showCheckerApprovalModal } from "../../components/CheckerModal";
import StepsCard from "../../components/layouts/enhancement/StepsCard";
import StepsComponent from "../../components/layouts/enhancement/StepsComponent";
import SuccessModal from "../../components/layouts/enhancement/SuccessModal";
import ContactInformationForm from "./components/ContactInformationForm";
import GeneralInformationForm from "./components/GeneralInformationForm";
import OthersForm from "./components/OthersForm";
import Preview from "./components/Preview";

const EditServiceProvider = (props) => {
  const { userData } = props;
  const { Text, Title } = Typography;
  const { session } = userData;
  const navigate = useNavigate();
  const [useForm] = Form.useForm();
  const { state: selectedBranchKey } = useLocation();
  const [current, setCurrent] = useState(0);

  // ENDPOINT DECLARED VARIABLES
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [productData, setProductData] = useState([]);
  const { state } = useLocation();
  const isActive = Form.useWatch("active", useForm);
  const idType = Form.useWatch("idTypeId", useForm);
  const openCasa = Form.useWatch("openCasa", useForm);
  const legalOption = Form.useWatch("legalFormId", useForm);
  const agentTypeWatch = Form.useWatch("agentType", useForm);
  const dispatch = useDispatch();
  const [officeData, setOfficeData] = useState([]);
  const [legalFormData, setLegalFormData] = useState([]);
  const [customerTypeData, setCustomerTypeData] = useState([]);
  const [titleData, setTitleData] = useState([]);
  const [savingsProduct, setSavingsProduct] = useState([]);
  const [clientClassificationData, setClientClassificationData] = useState([]);
  const [
    clientNonPersonConstitutionOptions,
    setClientNonPersonConstitutionOptions,
  ] = useState([]);
  const [
    clientNonPersonMainBusinessLineOptions,
    setClientNonPersonMainBusinessLineOptions,
  ] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [countryIdData, setCountryIdData] = useState([]);
  const [addressTypeIdData, setAddressTypeIdData] = useState([]);
  const [stateProvinceIdData, setStateProvinceIdData] = useState([]);
  const [genderData, setGenderData] = useState([]);
  const [identifactionTypeData, setIdentificattionTypeData] = useState([]);
  const [legalFormValue, setLegalFormValue] = useState(legalOption);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isProductSelected, setIsProductSelected] = useState(false);
  const [filteredWalletProduct, setFilteredWalletProduct] = useState([]);
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [warningModalVisible, setWarningModalVisible] = useState(false);
  const [originalList, setOriginalList] = useState([]);
  const [tableCount, setTableCount] = useState("10");
  const [customerList, setCustomerList] = useState([]);

  // ENDPOINT DECLARED VARIABLES
  const [formData, setFormData] = useState({
    generalInfo: null,
    contactInfo: null,
    othersInfo: null,
  });

  const disabledAfterCurrentDate = (current) => {
    return current && current.valueOf() > Date.now();
  };

  const minDate = dayjs().add(0, "day");

  const disableDaysBeforeToday = useCallback(
    (current) => {
      if (current == null) {
        return null;
      }

      return (
        minDate != null &&
        current.isBefore(minDate) &&
        !current.isSame(minDate, "day")
      );
    },
    [minDate],
  );

  useEffect(() => {
    getTemplate();
    getCustomerListAction();
    getProductTemplate();
  }, []);

  function getTemplate() {
    const url = `${apiConfig.Clients}/${state.id}?staffInSelectedOfficeOnly=true&template=true`;
    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setLegalFormValue(objDetail.legalForm.id);
        console.log(objDetail);

        useForm.setFieldsValue({
          agentType: objDetail?.agentMerchantData?.agentType,
          superAgentId: objDetail?.agentMerchantData?.superAgentId,
          tradingName: objDetail?.agentMerchantData?.tradingName,
          natureOfBusiness: objDetail?.agentMerchantData?.natureOfBusiness,
          businessRegistrationNumber:
            objDetail?.agentMerchantData?.businessRegistrationNumber,
          taxIdentificationNumber:
            objDetail?.agentMerchantData?.taxIdentificationNumber,
          businessDescription:
            objDetail?.agentMerchantData?.businessDescription,
          legalFormId: objDetail?.legalForm?.id,
          officeId: objDetail?.officeId,
          clientTypeId: objDetail?.clientType?.id,
          fullname: objDetail?.displayName,
          firstname: objDetail?.firstname,
          lastname: objDetail?.lastname,
          emailAddress: objDetail?.emailAddress,
          mobileNo: objDetail?.mobileNo,
          constitutionId: objDetail?.clientNonPersonDetails?.constitution?.id,
          mainBusinessLineId:
            objDetail?.clientNonPersonDetails?.mainBusinessLine?.id,
          accountNo: objDetail?.accountNo,
          active: objDetail?.active,
          isStaff: objDetail?.isStaff,
          dateOfBirth: objDetail?.dateOfBirth
            ? dayjs(BOM?.FormatArrayDate(objDetail?.dateOfBirth))
            : objDetail?.dateOfBirth,
          activationDate: objDetail?.timeline?.activatedOnDate
            ? dayjs(BOM?.FormatArrayDate(objDetail?.timeline?.activatedOnDate))
            : objDetail?.timeline?.activatedOnDate,
          submittedOnDate: objDetail?.timeline?.submittedOnDate
            ? dayjs(BOM?.FormatArrayDate(objDetail?.timeline?.submittedOnDate))
            : objDetail?.timeline?.submittedOnDate,
          genderId: objDetail?.gender?.id,
          externalId: objDetail?.externalId,
          staffId: objDetail?.staffId,
          clientClassificationId: objDetail?.clientClassification?.id,
          idTypeId: objDetail?.idType?.id,
          nationality: objDetail?.nationality,
          idNo: objDetail?.idNo,
          idIssuingDate: objDetail?.idIssuingDate
            ? dayjs(BOM?.FormatArrayDate(objDetail?.idIssuingDate))
            : objDetail?.idIssuingDate,
          passExpDate: objDetail?.passExpDate
            ? dayjs(BOM?.FormatArrayDate(objDetail?.passExpDate))
            : objDetail?.passExpDate,
        });

        let tempOfficeData = [];
        let tempLegalFormData = [];
        let tempCustomerType = [];
        let tempTitle = [];
        let tempCountries = [];
        let tempCountryId = [];
        let tempAddressTypeId = [];
        let tempStateProvinceId = [];
        let tempGender = [];
        let tempIdentification = [];
        let tempClientClassification = [];
        let tempClientNonPersonConstitutionOptions = [];
        let tempClientNonPersonMainBusinessLineOptions = [];
        let tempStaffData = [];
        let tempSavingsProduct = [];

        objDetail?.officeOptions?.forEach((element) => {
          tempOfficeData.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.clientLegalFormOptions?.forEach((element) => {
          tempLegalFormData.push({
            value: element.id,
            label: element.value,
          });
        });

        objDetail?.clientTypeOptions?.forEach((element) => {
          tempCustomerType.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.genderOptions?.forEach((element) => {
          tempGender.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.countryOptions?.forEach((element) => {
          tempCountries.push({
            value: element.description,
            label: element.name,
          });
        });

        objDetail?.clientClassificationOptions?.forEach((element) => {
          tempClientClassification.push({
            value: element.id,
            label: element.name,
          });
        });
        objDetail?.clientNonPersonConstitutionOptions?.forEach((element) => {
          tempClientNonPersonConstitutionOptions.push({
            value: element.id,
            label: element.name,
          });
        });

        objDetail?.clientNonPersonMainBusinessLineOptions?.forEach(
          (element) => {
            tempClientNonPersonMainBusinessLineOptions.push({
              value: element.id,
              label: element.name,
            });
          },
        );

        objDetail?.staffOptions?.forEach((element) => {
          tempStaffData.push({
            value: element.id,
            label: element.displayName,
          });
        });

        objDetail?.savingProductOptions
          ?.filter((item) => item.allowOverdraft === false)
          .forEach((element) => {
            tempSavingsProduct.push({
              value: element.id,
              label: element.name ? `${element.name} (${element.id})` : "",
            });
          });

        // objDetail?.savingProductOptions?.forEach((element) => {
        //   tempSavingsProduct.push({
        //     value: element.id,
        //     label: element.name,
        //   });
        // });

        objDetail?.idTypes?.forEach((element) => {
          tempIdentification.push({
            value: element.id,
            label: element.name,
          });
        });

        setOfficeData(tempOfficeData);
        setLegalFormData(tempLegalFormData);
        setCustomerTypeData(tempCustomerType);
        setTitleData(tempTitle);
        setSavingsProduct(tempSavingsProduct);
        // setActivationDate(objDetail?.activationDate);
        setClientClassificationData(tempClientClassification);
        setClientNonPersonConstitutionOptions(
          tempClientNonPersonConstitutionOptions,
        );
        setClientNonPersonMainBusinessLineOptions(
          tempClientNonPersonMainBusinessLineOptions,
        );
        setStaffData(tempStaffData);
        setCountryData(tempCountries);
        setCountryIdData(tempCountryId);
        setAddressTypeIdData(tempAddressTypeId);
        setStateProvinceIdData(tempStateProvinceId);
        setGenderData(tempGender);
        setIdentificattionTypeData(tempIdentification);
        setIsLoading(false);
      }
    });
  }

  // function getTemplate() {
  //   const url = `${apiConfig.Clients}/${state.id}?template=true`;
  //   let body = {
  //     session,
  //   };

  //   BOM.FetchReqAction(body, url, (err, res) => {
  //     if (err) {
  //       BOM.AlertMsg(cnt.DANGER, err);
  //       setIsLoading(false);
  //       return; // Early return on error
  //     }

  //     try {
  //       const objDetail = res;
  //       setLegalFormValue(objDetail.legalForm.id);
  //       console.log(objDetail.legalForm.id);

  //       // Separate concern: Set form fields
  //       setFormFields(objDetail);

  //       // Separate concern: Process dropdown options
  //       processDropdownOptions(objDetail);

  //       setIsLoading(false);
  //     } catch (error) {
  //       BOM.AlertMsg(cnt.DANGER, "Error processing template data");
  //       setIsLoading(false);
  //     }
  //   });
  // }

  function setFormFields(objDetail) {
    useForm.setFieldsValue({
      agentType: objDetail.agentMerchantData.agentType,
      superAgentId: objDetail.agentMerchantData.superAgentId,
      tradingName: objDetail.agentMerchantData.tradingName,
      natureOfBusiness: objDetail.agentMerchantData.natureOfBusiness,
      businessRegistrationNumber:
        objDetail.agentMerchantData.businessRegistrationNumber,
      taxIdentificationNumber:
        objDetail.agentMerchantData.taxIdentificationNumber,
      businessDescription: objDetail.agentMerchantData.businessDescription,
      legalFormId: objDetail.legalForm.id,
      officeId: objDetail.officeId,
      clientTypeId: objDetail.clientType.id,
      fullname: objDetail.displayName,
      firstname: objDetail.firstname,
      lastname: objDetail.lastname,
      emailAddress: objDetail.emailAddress,
      mobileNo: objDetail.mobileNo,
      constitutionId: objDetail.clientNonPersonDetails.constitution.id,
      mainBusinessLineId: objDetail.clientNonPersonDetails.mainBusinessLine.id,
      accountNo: objDetail.accountNo,
      active: objDetail.active,
      isStaff: objDetail?.isStaff,
      dateOfBirth: objDetail.dateOfBirth
        ? dayjs(BOM.FormatArrayDate(objDetail.dateOfBirth))
        : objDetail.dateOfBirth,
      activationDate: objDetail.timeline.activatedOnDate
        ? dayjs(BOM.FormatArrayDate(objDetail.timeline.activatedOnDate))
        : objDetail.timeline.activatedOnDate,
      submittedOnDate: objDetail.timeline.submittedOnDate
        ? dayjs(BOM.FormatArrayDate(objDetail.timeline.submittedOnDate))
        : objDetail.timeline.submittedOnDate,
      genderId: objDetail?.gender?.id,
      externalId: objDetail?.externalId,
      staffId: objDetail?.staffId,
      clientClassificationId: objDetail?.clientClassification?.id,
      idTypeId: objDetail?.idType?.id,
      idNumber: objDetail?.idNumber,
      idIssuingDate: objDetail?.idIssuingDate
        ? dayjs(BOM.FormatArrayDate(objDetail.idIssuingDate))
        : objDetail.idIssuingDate,
      passExpDate: objDetail?.passExpDate
        ? dayjs(BOM.FormatArrayDate(objDetail.passExpDate))
        : objDetail.passExpDate,
      incorpValidityTillDate: objDetail.clientNonPersonDetails
        ? dayjs(
            BOM.FormatArrayDate(
              objDetail.clientNonPersonDetails.incorpValidityTillDate,
            ),
          )
        : objDetail.clientNonPersonDetails.incorpValidityTillDate,
    });
  }

  function processDropdownOptions(objDetail) {
    const officeData = processArrayToOptions(
      objDetail?.officeOptions,
      "id",
      "name",
    );
    const legalFormData = processArrayToOptions(
      objDetail?.clientLegalFormOptions,
      "id",
      "value",
    );
    const customerTypeData = processArrayToOptions(
      objDetail?.clientTypeOptions,
      "id",
      "name",
    );
    const genderData = processArrayToOptions(
      objDetail?.genderOptions,
      "id",
      "name",
    );
    const countriesData = processArrayToOptions(
      objDetail?.countryOptions,
      "description",
      "name",
    );
    const clientClassificationData = processArrayToOptions(
      objDetail?.clientClassificationOptions,
      "id",
      "name",
    );
    const constitutionOptions = processArrayToOptions(
      objDetail?.clientNonPersonConstitutionOptions,
      "id",
      "name",
    );
    const mainBusinessLineOptions = processArrayToOptions(
      objDetail?.clientNonPersonMainBusinessLineOptions,
      "id",
      "name",
    );
    const staffData = processArrayToOptions(
      objDetail?.staffOptions,
      "id",
      "displayName",
    );
    const savingsProduct = processSavingsProducts(
      objDetail?.savingProductOptions,
    );
    const identificationData = processArrayToOptions(
      objDetail?.idTypes,
      "id",
      "name",
    );

    setOfficeData(officeData);
    setLegalFormData(legalFormData);
    setCustomerTypeData(customerTypeData);
    setSavingsProduct(savingsProduct);
    setClientClassificationData(clientClassificationData);
    setClientNonPersonConstitutionOptions(constitutionOptions);
    setClientNonPersonMainBusinessLineOptions(mainBusinessLineOptions);
    setStaffData(staffData);
    setCountryData(countriesData);
    setCountryIdData([]);
    setAddressTypeIdData([]);
    setStateProvinceIdData([]);
    setGenderData(genderData);
    setIdentificattionTypeData(identificationData);
  }

  function processArrayToOptions(array, valueKey, labelKey) {
    if (!array || !Array.isArray(array)) {
      return [];
    }

    return array.map((element) => ({
      value: element[valueKey],
      label: element[labelKey],
    }));
  }

  function processSavingsProducts(savingProductOptions) {
    if (!savingProductOptions || !Array.isArray(savingProductOptions)) {
      return [];
    }

    return savingProductOptions
      .filter((item) => item.allowOverdraft === false)
      .map((element) => ({
        value: element.id,
        label: element.name ? `${element.name} (${element.id})` : "",
      }));
  }

  const getCustomerListAction = (offset = 0, limit = Number(tableCount)) => {
    const params = {
      // limit: limit,
      offset: offset,
      orderBy: "id",
      agentMerchantOnly: true,
    };

    let body = {
      session,
      params,
    };

    setIsLoading(true);
    BOM.FetchReqAction(body, apiConfig.Clients, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res.pageItems;

        const filteredItems = objList.filter((item) => {
          const type = item.agentMerchantData?.agentType;
          return ["AGENT", "MERCHANT", "SUPER_AGENT"].includes(type);
        });

        let tempArray = [];

        filteredItems.forEach((element) => {
          const statusValue = element?.status ? element?.status.value : "-";
          tempArray.push({
            key: element?.agentMerchantData?.id,
            id: element?.agentMerchantData?.id,
            name: element?.displayName ? element?.displayName : "-",
            clientno: element?.accountNo ? element?.accountNo : "-",
            mobileNo: element?.mobileNo ? element?.mobileNo : "-",
            status:
              statusValue?.toLowerCase() === "submitted and pending approval"
                ? "Pending"
                : statusValue,
            branch: element?.officeName ? element?.officeName : "-",
            staff: element?.staffName ? element?.staffName : "-",
            branchId: element?.officeId ? element?.officeId : "-",
            agentType: element?.agentMerchantData?.agentType,
          });
        });

        setCustomerList(tempArray);
        setOriginalList(tempArray);
        setIsLoading(false);
      }
    });
  };

  const getProductTemplate = () => {
    const url = `${apiConfig.WalletAccount}/template`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        console.log(res);
        let tempProducts = [];

        objList?.walletsProductDataList.forEach((element) => {
          tempProducts.push({
            value: element.savingsProductData.id,
            label: element.savingsProductData.name
              ? `${element.savingsProductData.name} (${element.id})`
              : "",
          });
        });

        setProductData(tempProducts);
      }
    });
  };

  const onFinishgeneralInfoForm = (values) => {
    console.log(values);
    setLegalFormValue(values.legalFormId);
    setFormData({ ...formData, generalInfo: values });

    setCurrent(current + 1);
  };

  const onFinishContactInformationForm = (values) => {
    console.log(values);

    setFormData({ ...formData, contactInfo: values });
    setCurrent(current + 1);
  };

  const onFinishOthersForm = (values) => {
    console.log(values);

    setFormData({ ...formData, othersInfo: values });
    setCurrent(current + 1);
  };

  const stepsContent = [
    {
      title: "General Information",
      component: (
        <GeneralInformationForm
          onFinish={onFinishgeneralInfoForm}
          form={useForm}
          isCreateScreen={false}
          initialValues={formData.generalInfo}
          userData={userData}
          isActive={isActive}
          legalFormData={legalFormData}
          officeData={officeData}
          legalOption={legalOption}
          customerTypeData={customerTypeData}
          genderData={genderData}
          disabledAfterCurrentDate={disabledAfterCurrentDate}
          agentType={agentTypeWatch}
          customerList={customerList}
          disableDaysBeforeToday={disableDaysBeforeToday}
          clientNonPersonMainBusinessLineOptions={
            clientNonPersonMainBusinessLineOptions
          }
          clientNonPersonConstitutionOptions={
            clientNonPersonConstitutionOptions
          }
        />
      ),
    },
    {
      title: "Contact Information",
      component: (
        <ContactInformationForm
          onFinish={onFinishContactInformationForm}
          current={current}
          isCreateScreen={false}
          setCurrent={setCurrent}
          initialValues={formData.contactInfo}
          form={useForm}
          identifactionTypeData={identifactionTypeData}
          legalOption={legalFormValue}
          countryData={countryData}
          idType={idType}
          disabledAfterCurrentDate={disabledAfterCurrentDate}
          disableDaysBeforeToday={disableDaysBeforeToday}
          isLoading={isLoading}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          addressTypeIdData={addressTypeIdData}
          stateProvinceIdData={stateProvinceIdData}
          countryIdData={countryIdData}
        />
      ),
    },
    {
      title: "Others",
      component: (
        <OthersForm
          onFinish={onFinishOthersForm}
          current={current}
          setCurrent={setCurrent}
          initialValues={formData.othersInfo}
          form={useForm}
          walletProduct={productData}
          openCasa={openCasa}
          clientClassificationData={clientClassificationData}
          staffData={staffData}
          isCreateScreen={false}
        />
      ),
    },
    {
      title: "Preview",
      component: (
        <Preview
          formData={formData}
          // useCases={useCases}
          productData={productData}
          filteredWalletProduct={filteredWalletProduct}
          addressTypeIdData={addressTypeIdData}
          legalFormData={legalFormData}
          officeData={officeData}
          genderData={genderData}
          stateProvinceIdData={stateProvinceIdData}
          countryData={countryData}
          legalOption={legalOption}
          customerList={customerList}
          isCreateScreen={false}
          clientNonPersonConstitutionOptions={
            clientNonPersonConstitutionOptions
          }
          clientNonPersonMainBusinessLineOptions={
            clientNonPersonMainBusinessLineOptions
          }
        />
      ),
    },
  ];

  const next = () => {
    const stepsUsingForm = [0, 1, 2, 3];

    if (stepsUsingForm.includes(current)) {
      useForm.submit();
    } else {
      setCurrent(current + 1);
    }
  };

  const prev = () => {
    const prevStep = current - 1;
    setCurrent(prevStep);

    // Remove the last completed step if going back
    setCompletedSteps((prev) => {
      const updated = prev.filter((stepIndex) => stepIndex < prevStep);
      return updated;
    });
  };

  const handleGoBack = () => {
    navigate("/service-provider");
  };

  const handleSubmit = (formValues) => {
    formValues = {
      ...formData.generalInfo,
      ...formData.contactInfo,
      ...formData.othersInfo,
    };

    const url = `${apiConfig.Clients}/${state.id}`;

    formValues.dateOfBirth = formValues.dateOfBirth
      ? BOM.DateTime(formValues.dateOfBirth, "only-date")
      : formValues.dateOfBirth;
    formValues.activationDate = formValues.activationDate
      ? BOM.DateTime(formValues.activationDate, "only-date")
      : formValues.activationDate;
    formValues.submittedOnDate = formValues.submittedOnDate
      ? BOM.DateTime(formValues.submittedOnDate, "only-date")
      : formValues.submittedOnDate;
    formValues.idIssuingDate = formValues.idIssuingDate
      ? BOM.DateTime(formValues.idIssuingDate, "only-date")
      : formValues.idIssuingDate;
    formValues.passExpDate = formValues.passExpDate
      ? BOM.DateTime(formValues.passExpDate, "only-date")
      : formValues.passExpDate;

    formValues.clientNonPersonDetails = {
      constitutionId: formValues.constitutionId,
      dateFormat: "dd MMMM yyyy",
      incorpNumber: formValues.incorpNumber,
      incorpValidityTillDate: formValues.incorpValidityTillDate
        ? BOM.DateTime(formValues.incorpValidityTillDate, "only-date")
        : formValues.incorpValidityTillDate,
      locale: "en",
      mainBusinessLineId: formValues.mainBusinessLineId,
      remarks: formValues.remarks,
    };

    delete formValues.officeId;
    delete formValues.openCasa;
    delete formValues.constitutionId;
    delete formValues.incorpNumber;
    delete formValues.incorpValidityTillDate;
    delete formValues.mainBusinessLineId;
    delete formValues.remarks;

    const body = {
      ...formValues,
      dateFormat: "dd MMMM yyyy",
      locale: "en",
      method: "PUT",
      session,
    };

    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        // This callback ONLY runs when there's NO commandId
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        } else {
          // Show success message - we know there's no commandId here
          BOM.AlertMsg(
            cnt.SUCCESS,
            "Service Provider has been updated successfully.",
          );
          navigate("/service-provider", {
            state: { ...state },
          });
        }
        setIsLoading(false);
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/service-provider", {
            state: { ...state },
          });
          setIsLoading(false);
        },
      },
    );
  };

  return (
    <MainLayout pageItems={staticConfig.editBreadcrumbItems}>
      <TopContent
        pageTitle={labelConfig.editServiceProvider}
        createPageTitle={labelConfig.updateServiceProvider}
      />
      <Spin spinning={isLoading} size="large">
        <div
          className="contract-form-container"
          style={{
            display: "flex",
            paddingLeft: "44px",
            marginTop: "20px",
            height: "720px",
            widtth: "100%",
          }}
        >
          {/* Left side - Vertical steps */}
          <StepsComponent
            steps={stepsContent}
            current={current}
            completedSteps={completedSteps}
          />

          <StepsCard
            current={current}
            onNext={next}
            onPrev={prev}
            totalSteps={4}
            nextLabel={`Next - ${stepsContent[current + 1]?.title || ""}`}
            onSubmit={handleSubmit}
            submitLabel="Update"
            onGoBack={handleGoBack}
          >
            {stepsContent[current].component}
          </StepsCard>
          {/* 
          <SuccessModal
            visible={isModalVisible}
            onClose={handleGoBack}
            successMessage={"Service Provider has been updated successfully."}
            isCreateButton={false}
          /> */}
        </div>
      </Spin>
    </MainLayout>
  );
};

export default EditServiceProvider;
